import { MCBHS171SearchRequest } from 'types/MCBHS171/MCBHS171SearchRequest'
import request from 'utils/request'

export const getMCBHS171InitRequest = (apiData: MCBHS171SearchRequest) =>
  request({
    url: '/MCBHS171/init',
    method: 'post',
    data: apiData
  })
